// extracted by mini-css-extract-plugin
export default {"container":"Error404_container__MS380","messageContainer":"Error404_messageContainer__+CZVy"};